import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { computed, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { Form } from 'ant-design-vue'
import { toBeijingTime } from '@/utils/timeFormat'
const __default__ = { name: 'CosRangePicker' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: String
  },
  showTime: {
    type: [Boolean, Object],
    default: false
  },
  valueFormat: String,
  // 输出北京时间
  isOutputBeijingTime: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:value', 'ok'],
  setup(__props, { emit: __emit }) {

const formItemContext = Form.useInjectFormItemContext()
const props = __props
const emit = __emit
const time = ref<any>([])
const resultTime = ref()
watch(
  () => props.value,
  (v, prev) => {
    if (v && !resultTime.value) {
      time.value = dayjs(v)
    } else if (!v) {
      time.value = undefined
    }
  },
  { immediate: true }
)
const formFormat = computed(() => {
  return props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
})
const ok = () => {
  const format = props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
  const rtime = dayjs(time.value).format(format)
  resultTime.value = rtime
  const emitValue = props.isOutputBeijingTime ? toBeijingTime(rtime) : rtime
  emit('update:value', emitValue)
  emit('ok')
  formItemContext.onFieldChange()
}

return (_ctx: any,_cache: any) => {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!

  return (_openBlock(), _createBlock(_component_a_date_picker, _mergeProps({
    style: {"width":"100%"},
    showTime: __props.showTime,
    value: time.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((time).value = $event))
  }, _ctx.$attrs, {
    valueFormat: formFormat.value,
    onOk: ok
  }), null, 16, ["showTime", "value", "valueFormat"]))
}
}

})